<script setup lang="ts">
    import { defineProps, withDefaults, toRefs } from "vue";
    import KRepeater from "@/components/forms/groups/Repeater/KRepeater.vue";
    import { dynamicPropsRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import MaterialAutocomplete from "./MaterialAutocomplete.vue";

    interface Props {
        name?: string;
        label?: string;
        add_label?: string;
        remove_label?: string;
        urlParams?: { [key: string]: unknown };
    }

    const props = withDefaults(defineProps<Props>(), {
        name: "material",
        label: "Material",
        add_label: "Lägg till material",
        remove_label: "Ta bort material",
        urlParams: () => ({}),
    });

    const { name, label, add_label, remove_label, urlParams } = toRefs(props);
</script>

<template>
    <KRepeater
        :name="name"
        :add-label="add_label"
        :remove-label="remove_label"
        #default="{ index, model }"
        :converter="dynamicPropsRepeaterConverter"
    >
        <MaterialAutocomplete
            class="span-two"
            name="id"
            :label="label"
            :value="model?.[index]?.id ?? null"
            :url-params="urlParams"
        />
        <slot name="otherfields" :index="index" :model="model"></slot>
    </KRepeater>
</template>

<style scoped lang="scss"></style>
